<div
  class="card"
  *appIsGranted="['VAN_TRANSFER', 'VAN_TRANSFER_ROUTES', 'READ']"
>
  <div class="card-header">
    <div class="row">
      <div class="col-md-9"><h6>Van Transfer</h6></div>
      <div class="col-md-3">
        <div class="dropdown mt-1" ngbDropdown>
          <button
            *appIsGranted="['VAN_TRANSFER', 'VAN_TRANSFER_ROUTES', 'CREATE']"
            class="btn btn-sm btn-primary dropdown-toggle ms-3"
            type="button"
            id="dropdownMenuButton"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            ngbDropdownToggle
          >
            Novo local <i class="mdi mdi-chevron-down"></i>
          </button>
          <div
            class="dropdown-menu"
            aria-labelledby="dropdownMenuButton"
            ngbDropdownMenu
          >
            <ng-container *ngFor="let item of vanTransferLocal">
              <a
                *appIsGranted="[
                  'VAN_TRANSFER',
                  'VAN_TRANSFER_ROUTES',
                  'UPDATE'
                ]"
                class="dropdown-item"
                href="javascript:void(0);"
                (click)="openEdit(item.id)"
                >{{ returnLocal(item.id) }}</a
              >
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card align-items-center" *ngIf="circularProgressiveWait">
        <div card="card-body">
          <div class="spinner-border text-primary m-1" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <div class="card-body"></div>
      <table class="table table-fit table-bordered table-hover">
        <thead class="table-primary">
          <tr>
            <th scope="col">Localização</th>
            <th scope="col">Rotas</th>
            <!-- <th scope="col">Placas vinculadas</th> -->
            <th scope="col">Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let route of routesGrid">
            <td class="col-md-2 user-select-all" scope="row">
              {{ returnLocal(route.localId) }}
            </td>

            <td class="col-md-3 user-select-all" scope="row">
              {{ returnRoutesName(route.localId) }}
            </td>
            <!-- <td class="col-md-2 user-select-all" scope="row">
              {{ route.isActive }}
            </td> -->
            <td class="col-md-1" scope="row">
              <div class="d-inline">
                <i-feather
                  *appIsGranted="[
                    'VAN_TRANSFER',
                    'VAN_TRANSFER_ROUTES',
                    'UPDATE'
                  ]"
                  class="card"
                  ngbTooltip="Editar"
                  name="edit"
                  style="color: blue"
                  (click)="openEdit(route.localId)"
                >
                </i-feather>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="card align-items-center"
      *ngIf="circularProgressiveWait && editOrAdd"
    >
      <div card="card-body">
        <div class="spinner-border text-primary m-1" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div id="map" class="w-100 h-100" [fluidHeight]></div>
      </div>
      <div class="col-md-6 ml-4">
        <div *ngIf="editOrAdd">
          <div class="card-body">
            <div class="card">
              <div
                class="card-header justify-content-between d-flex align-items-center"
              >
                <div id="terminals">
                  <div class="d-flex">
                    <h3>
                      {{ returnLocal(localRoutesAreasEdit[0].localId) }}
                    </h3>
                    <ng-container
                      *ngIf="
                        localRoutesAreasEdit[0].routesPolyline != undefined
                      "
                    >
                      <button
                        *appIsGranted="[
                          'VAN_TRANSFER',
                          'VAN_TRANSFER_ROUTES',
                          'CREATE'
                        ]"
                        class="btn btn-sm btn-primary mb-3"
                        (click)="newRoute()"
                      >
                        Adicionar Nova Rota
                      </button>
                    </ng-container>
                  </div>

                  <ng-container
                    class="card"
                    *ngFor="
                      let item of localRoutesAreasEdit;
                      let iRoutes = index
                    "
                  >
                    <div class="card-body general_faq accordion_exp">
                      <ngb-accordion
                        #acc="ngbAccordion"
                        [activeIds]="'static-' + iRoutes"
                        [closeOthers]="true"
                      >
                        <ngb-panel [id]="'static-' + iRoutes">
                          <ng-template ngbPanelTitle class="accordion-header">
                            <h2
                              class="accordion-header"
                              [id]="'gen-ques-heading' + iRoutes"
                            >
                              <button
                                class="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#gen-ques-collapse"
                                aria-expanded="false"
                                aria-controls="gen-ques-collapse"
                              >
                                {{ item.routes.name }}
                              </button>
                            </h2>
                          </ng-template>
                          <ng-template ngbPanelContent>
                            <div
                              class="align-items-center"
                              style="display: inline-flex"
                            >
                              <div
                                class="circle m-2"
                                [ngStyle]="{
                                  'background-color':
                                    wizardState == 1 ? 'orange' : 'gray'
                                }"
                              >
                                1
                              </div>
                              <div
                                class="circle m-2"
                                [ngStyle]="{
                                  'background-color':
                                    wizardState == 2 ? 'orange' : 'gray'
                                }"
                              >
                                2
                              </div>
                              <div
                                class="circle m-2"
                                [ngStyle]="{
                                  'background-color':
                                    wizardState == 3 ? 'orange' : 'gray'
                                }"
                              >
                                3
                              </div>
                              <div
                                class="circle m-2"
                                [ngStyle]="{
                                  'background-color':
                                    wizardState == 4 ? 'orange' : 'gray'
                                }"
                              >
                                4
                              </div>
                            </div>

                            <ng-container>
                              <div *ngIf="wizardState == 1">
                                <div class="wizard-list-item">
                                  <div class="list-item">
                                    <div
                                      class="step-icon"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Loja Movida"
                                    >
                                      <i class="uil uil-map-marker-info"></i>
                                    </div>
                                  </div>
                                </div>

                                <div class="row">
                                  <div class="text-center mb-4">
                                    <h5>
                                      Loja Movida
                                      <img
                                        class="png-icon"
                                        src="../../../../assets/images/loja_movida.png"
                                        style="width: 24px; height: 24px"
                                      />
                                    </h5>
                                  </div>
                                  <div>
                                    <button
                                      *appIsGranted="[
                                        'VAN_TRANSFER',
                                        'VAN_TRANSFER_ROUTES',
                                        'CREATE'
                                      ]"
                                      class="btn btn-sm btn-primary"
                                      [ngStyle]="{
                                        display:
                                          item.markerMovida != undefined &&
                                          item.markerMovida.length < 2
                                            ? 'none'
                                            : ''
                                      }"
                                      (click)="addMarkerMovida(item)"
                                    >
                                      Nova loja
                                    </button>
                                  </div>
                                  <ng-container
                                    *ngIf="item.markerMovida != undefined"
                                  >
                                    <div
                                      class="shadow p-3 mb-5 bg-gray rounded bg-light"
                                    >
                                      <div class="row">
                                        <div class="col-md-1">
                                          <img
                                            class="png-icon"
                                            src="../../../../assets/images/loja_movida.png"
                                            style="width: 24px; height: 24px"
                                          />
                                        </div>
                                        <div class="col-md-2">
                                          <i-feather
                                            class="card"
                                            ngbTooltip="Editar"
                                            name="edit"
                                            style="color: blue"
                                            *appIsGranted="[
                                              'VAN_TRANSFER',
                                              'VAN_TRANSFER_ROUTES',
                                              'UPDATE'
                                            ]"
                                            (click)="
                                              changeEditableMarkerMovida(
                                                item.markerMovida,
                                                iRoutes
                                              )
                                            "
                                          ></i-feather>

                                          <i-feather
                                            *appIsGranted="[
                                              'VAN_TRANSFER',
                                              'VAN_TRANSFER_ROUTES',
                                              'DELETE'
                                            ]"
                                            class="card"
                                            ngbTooltip="Apagar"
                                            name="trash-2"
                                            style="
                                              color: red;
                                              display: inline-table;
                                            "
                                            (click)="
                                              excludeMarkerMovida(
                                                item.markerMovida,
                                                iRoutes
                                              )
                                            "
                                          ></i-feather>
                                        </div>
                                        <div class="col-md-9 align-items-start">
                                          Loja Movida
                                        </div>
                                      </div>
                                    </div>
                                  </ng-container>
                                </div>
                                <ul class="list-inline wizard mb-0">
                                  <li class="next list-inline-item float-end">
                                    <button
                                      class="btn btn-primary w-sm"
                                      awNextStep
                                      (click)="
                                        clearDrawing();
                                        wizardState = wizardState + 1
                                      "
                                    >
                                      Próximo
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </ng-container>
                            <ng-container>
                              <div *ngIf="wizardState == 2">
                                <div class="wizard-list-item">
                                  <div class="list-item">
                                    <div
                                      class="step-icon"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Terminal de embarque"
                                    >
                                      <i class="uil uil-map-pin-alt"></i>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="text-center mb-4">
                                    <h5>
                                      Terminal
                                      <img
                                        class="png-icon"
                                        src="../../../../assets/images/terminal.png"
                                        style="width: 24px; height: 24px"
                                      />
                                    </h5>
                                    <p class="card-title-desc">
                                      Terminal de embarque
                                    </p>
                                  </div>
                                  <div>
                                    <button
                                      *appIsGranted="[
                                        'VAN_TRANSFER',
                                        'VAN_TRANSFER_ROUTES',
                                        'CREATE'
                                      ]"
                                      class="btn btn-sm btn-primary mb-3"
                                      (click)="addMarkerTerminals(item)"
                                    >
                                      Novo Terminal
                                    </button>
                                  </div>
                                  <ng-container
                                    *ngIf="item.markerTerminals != undefined"
                                  >
                                    <div
                                      class="shadow p-3 mb-5 bg-gray rounded bg-light"
                                    >
                                      <ng-container
                                        *ngFor="
                                          let markerTerminals of item.markerTerminals;
                                          let indexMarkerTerminals = index
                                        "
                                      >
                                        <div class="row">
                                          <div class="col-md-1">
                                            <img
                                              class="png-icon"
                                              src="../../../../assets/images/terminal.png"
                                              style="width: 24px; height: 24px"
                                            />
                                          </div>
                                          <div class="col-md-2">
                                            <i-feather
                                              *appIsGranted="[
                                                'VAN_TRANSFER',
                                                'VAN_TRANSFER_ROUTES',
                                                'UPDATE'
                                              ]"
                                              class="card"
                                              ngbTooltip="Editar"
                                              name="edit"
                                              style="color: blue"
                                              (click)="
                                                changeEditableMarkerTerminal(
                                                  item.markerTerminals,
                                                  iRoutes
                                                )
                                              "
                                            ></i-feather>

                                            <i-feather
                                              *appIsGranted="[
                                                'VAN_TRANSFER',
                                                'VAN_TRANSFER_ROUTES',
                                                'DELETE'
                                              ]"
                                              class="card"
                                              ngbTooltip="Apagar"
                                              name="trash-2"
                                              style="
                                                color: red;
                                                display: inline-table;
                                              "
                                              (click)="
                                                excludeMarkerTerminal(
                                                  item.markerTerminals,
                                                  iRoutes,
                                                  indexMarkerTerminals
                                                )
                                              "
                                            ></i-feather>
                                          </div>
                                          <div
                                            class="col-md-9 align-items-start"
                                          >
                                            Terminals -
                                            {{ indexMarkerTerminals + 1 }}
                                          </div>
                                        </div>
                                      </ng-container>
                                    </div>
                                  </ng-container>
                                </div>
                                <ul class="list-inline wizard mb-0">
                                  <li class="previous list-inline-item">
                                    <button
                                      class="btn btn-primary"
                                      awPreviousStep
                                      (click)="
                                        clearDrawing();
                                        wizardState = wizardState - 1
                                      "
                                    >
                                      Voltar
                                    </button>
                                  </li>
                                  <li class="next list-inline-item float-end">
                                    <button
                                      class="btn btn-primary w-sm"
                                      (click)="
                                        clearDrawing();
                                        wizardState = wizardState + 1
                                      "
                                    >
                                      Próximo
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </ng-container>
                            <ng-container>
                              <div *ngIf="wizardState == 3">
                                <ng-template awWizardStepSymbol>
                                  <div class="wizard-list-item">
                                    <div class="list-item">
                                      <div
                                        class="step-icon"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Rota"
                                      >
                                        <i class="uil uil-arrow-growth"></i>
                                      </div>
                                    </div>
                                  </div>
                                </ng-template>
                                <div class="row justify-content-center">
                                  <div class="text-center">
                                    <h5>Rota</h5>
                                    <p class="card-title-desc">
                                      Rota partindo da loja até o terminal
                                    </p>
                                  </div>
                                  <ng-container
                                    *ngIf="item.routesPolyline == undefined"
                                  >
                                    <div class="d-inline">
                                      <button
                                        *appIsGranted="[
                                          'VAN_TRANSFER',
                                          'VAN_TRANSFER_ROUTES',
                                          'CREATE'
                                        ]"
                                        class="btn btn-sm btn-primary m-3"
                                        [ngStyle]="{
                                          display:
                                            item.routes.name == '' ? 'none' : ''
                                        }"
                                        [disabled]="item.routes.name == ''"
                                        (click)="
                                          item.routes.name == ''
                                            ? null
                                            : addRoute()
                                        "
                                      >
                                        Desenhar rota
                                      </button>
                                      <input
                                        type="text"
                                        maxlength="40"
                                        [(ngModel)]="item.routes.name"
                                        placeholder="Digite um nome para rota"
                                      />
                                    </div>
                                    <ng-container
                                      *ngIf="item.routes.name == ''"
                                    >
                                      <span class="text-danger"
                                        ><b>Digite um nome para a rota</b></span
                                      >
                                    </ng-container>
                                  </ng-container>
                                  <ng-container
                                    *ngIf="item.routesPolyline != undefined"
                                  >
                                    <div
                                      class="shadow p-3 mb-5 bg-gray rounded bg-light"
                                    >
                                      <div style="display: inline-table">
                                        <i-feather
                                          class="card"
                                          ngbTooltip="Visualizar"
                                          name="eye"
                                          style="color: orange"
                                          (click)="
                                            item.routesPolyline == undefined
                                              ? null
                                              : changeVisible(item)
                                          "
                                        ></i-feather>

                                        <i-feather
                                          *appIsGranted="[
                                            'VAN_TRANSFER',
                                            'VAN_TRANSFER_ROUTES',
                                            'UPDATE'
                                          ]"
                                          class="card"
                                          ngbTooltip="Editar"
                                          name="edit"
                                          style="color: blue"
                                          (click)="
                                            item.routesPolyline == undefined
                                              ? null
                                              : changeEditable(item)
                                          "
                                        ></i-feather>

                                        <i-feather
                                          *appIsGranted="[
                                            'VAN_TRANSFER',
                                            'VAN_TRANSFER_ROUTES',
                                            'DELETE'
                                          ]"
                                          class="card"
                                          ngbTooltip="Deletar"
                                          name="delete"
                                          style="color: red"
                                          (click)="deleteRoute(iRoutes)"
                                        ></i-feather>
                                        - <b>{{ item.routes.name }}</b>
                                      </div>
                                    </div>
                                  </ng-container>
                                </div>
                                <ul class="list-inline wizard mb-0">
                                  <li class="previous list-inline-item">
                                    <button
                                      class="btn btn-primary"
                                      awPreviousStep
                                      (click)="
                                        clearDrawing();
                                        wizardState = wizardState - 1
                                      "
                                    >
                                      Voltar
                                    </button>
                                  </li>
                                  <li class="next list-inline-item float-end">
                                    <button
                                      *ngIf="item.routesPolyline != undefined"
                                      class="btn btn-primary w-sm"
                                      awNextStep
                                      (click)="
                                        clearDrawing();
                                        wizardState = wizardState + 1
                                      "
                                    >
                                      Próximo
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </ng-container>
                            <ng-container>
                              <div *ngIf="wizardState == 4">
                                <ng-template awWizardStepSymbol>
                                  <div class="wizard-list-item">
                                    <div class="list-item">
                                      <div
                                        class="step-icon"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Áreas"
                                      >
                                        <i class="uil uil-map"></i>
                                      </div>
                                    </div>
                                  </div>
                                </ng-template>
                                <div class="row">
                                  <div class="text-center mb-4">
                                    <h5>Áreas</h5>
                                    <p class="card-title-desc">
                                      Áreas onde os véiculos vão aparecer,<br />tempos
                                      estimado e mensagem.
                                    </p>
                                  </div>
                                  <ng-container
                                    *ngIf="item.routesPolyline != undefined"
                                  >
                                    <td>
                                      <div class="d-inline">
                                        <button
                                          *appIsGranted="[
                                            'VAN_TRANSFER',
                                            'VAN_TRANSFER_ROUTES',
                                            'CREATE'
                                          ]"
                                          class="btn btn-sm btn-primary"
                                          ngbTooltip="Adicionar Area"
                                          (click)="addArea(item)"
                                        >
                                          Adicionar nova área
                                        </button>
                                        <i-feather
                                          class="card"
                                          ngbTooltip="Visualizar"
                                          name="eye"
                                          style="color: orange"
                                          (click)="
                                            item.routesPolyline == undefined
                                              ? null
                                              : changeVisibleArea(item.areas)
                                          "
                                        ></i-feather>
                                      </div>
                                    </td>
                                    <td>
                                      <table
                                        class="table-fit table-bordered table-primary"
                                      >
                                        <thead>
                                          <tr>
                                            <th scope="col-md-1">Cor</th>
                                            <th scope="col-md-1">Ordem</th>
                                            <th scope="col-md-2">
                                              Tempo Estimado
                                            </th>
                                            <th scope="col-md-6">Mensagem</th>
                                            <th scope="col-md-2">Ação</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <ng-container
                                            *ngFor="
                                              let itemArea of item.areas;
                                              let iArea = index
                                            "
                                          >
                                            <tr>
                                              <td
                                                scope="row"
                                                [ngStyle]="{
                                                  'background-color':
                                                    itemArea.color
                                                }"
                                              ></td>
                                              <td scope="row">
                                                {{ iArea + 1 }}
                                              </td>
                                              <td scope="row">
                                                <input
                                                  class="input w-75"
                                                  type="number"
                                                  [(ngModel)]="
                                                    itemArea.area.estimatedTime
                                                  "
                                                />
                                              </td>
                                              <td scope="row">
                                                <input
                                                  type="text"
                                                  maxlength="30"
                                                  [(ngModel)]="
                                                    itemArea.area.message
                                                  "
                                                />
                                              </td>
                                              <td scope="row">
                                                <i-feather
                                                  *appIsGranted="[
                                                    'VAN_TRANSFER',
                                                    'VAN_TRANSFER_ROUTES',
                                                    'UPDATE'
                                                  ]"
                                                  class="card"
                                                  ngbTooltip="Editar"
                                                  name="edit"
                                                  style="color: blue"
                                                  (click)="
                                                    changeEditableArea(itemArea)
                                                  "
                                                ></i-feather>
                                                <i-feather
                                                  *appIsGranted="[
                                                    'VAN_TRANSFER',
                                                    'VAN_TRANSFER_ROUTES',
                                                    'DELETE'
                                                  ]"
                                                  class="card"
                                                  ngbTooltip="Apagar"
                                                  name="trash-2"
                                                  style="
                                                    color: red;
                                                    display: inline-table;
                                                  "
                                                  (click)="
                                                    excludeArea(
                                                      itemArea,
                                                      iRoutes,
                                                      iArea
                                                    )
                                                  "
                                                ></i-feather>
                                              </td>
                                            </tr>
                                          </ng-container>
                                        </tbody>
                                      </table>
                                    </td>
                                  </ng-container>
                                </div>
                                <ul class="list-inline wizard mb-0">
                                  <li class="previous list-inline-item">
                                    <button
                                      class="btn btn-primary"
                                      awPreviousStep
                                      (click)="
                                        clearDrawing();
                                        wizardState = wizardState - 1
                                      "
                                    >
                                      Voltar
                                    </button>
                                  </li>
                                  <li class="next list-inline-item float-end">
                                    <button
                                      class="btn btn-sm btn-primary"
                                      type="submit"
                                      (click)="saveRoutes(); clearDrawing()"
                                    >
                                      Salvar
                                    </button>

                                    <button
                                      class="btn btn-sm btn-danger"
                                      type="submit"
                                      (click)="
                                        openEdit(null);
                                        clearDrawing();
                                        wizardState = wizardState = 1
                                      "
                                    >
                                      Cancelar
                                    </button>
                                  </li>
                                </ul>
                              </div></ng-container
                            >
                          </ng-template>
                        </ngb-panel>
                      </ngb-accordion>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
